import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <main className="cart-page__main">
          <div className="cart-page__empty">
            <h1 className="cart-page__empty-title">Your cart is empty</h1>
            <Link onClick={toTop} to="/shop" className="cart-page__continue-shopping">
              Continue shopping
            </Link>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <main className="cart-page__main">
        <div className="cart-page__content">
          <div className="cart-page__left">
            <div className="cart-page__header">
              <h1 className="cart-page__title">Your cart</h1>
              <p className="cart-page__item-count">{cartItems.length} item{cartItems.length !== 1 ? 's' : ''}</p>
            </div>

            <div className="cart-page__items">
              {cartItems.map((item) => {
                const product = getProductById(item.id);
                if (!product) return null;

                return (
                  <div key={`${item.id}-${item.size}-${item.color}`} className="cart-item">
                    <Link 
                      to={`/shopDetails/${product.id}`} 
                      onClick={toTop}
                      className="cart-item__image"
                    >
                      <img src={product.image} alt={product.name} />
                    </Link>
                    <div className="cart-item__details">
                      <div className="cart-item__info">
                        <Link 
                          to={`/shopDetails/${product.id}`} 
                          onClick={toTop}
                          className="cart-item__name"
                        >
                          {product.name}
                        </Link>
                        <p className="cart-item__price">${product.price}</p>
                      </div>

                      <div className="cart-item__quantity">
                        <div className="quantity-controls">
                          <button 
                            className="quantity-btn"
                            onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity - 1)}
                          >−</button>
                          <span className="quantity-value">{item.quantity}</span>
                          <button 
                            className="quantity-btn"
                            onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity + 1)}
                          >+</button>
                        </div>
                      </div>

                      <p>
                        {item.size&&(
                          <span>{item.size}</span>
                        )}
                        -
                         {item.color&&(
                          <span>{item.color}</span>
                        )}
                      </p>

                      <button 
                        className="cart-item__remove"
                        onClick={() => removeFromCart(item.id, item.size, item.color)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            <Link onClick={toTop} to="/shop" className="cart-page__continue-shopping">
              Continue shopping
            </Link>
          </div>

          <div className="cart-page__right">
            <div className="cart-summary">
              <div className="cart-summary__row">
                <span className="cart-summary__label">Subtotal</span>
                <span className="cart-summary__value">${subtotal.toFixed(2)}</span>
              </div>
              <p className="cart-summary__note">Taxes and shipping calculated at checkout</p>
              
              <button className="cart-summary__checkout" onClick={handleCheckout}>
                Checkout
              </button>
              
            
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CartPage;
